// @flow

import $ from 'jquery'

export const updateTypeText = ($button: JQuery) => {
  let text = ''
  const type = $button.attr('data-type')

  switch (type) {
    case 'solve':
      text = 'Это раздел с тестами и тренажёрами. Открывайте подходящий и спокойно оставляйте ребёнка за экраном.'
      break
    case 'have-fun':
      text = 'Это раздел с мультфильмами и играми. Всё, что есть внутри, озвучено — вам остаётся переключать серии.'
      break
    case 'learn':
      text = 'Это раздел с онлайн-курсами. Ребёнок разовьёт новый навык или укрепит старый, а вы успеете отдохнуть.'
      break
    case 'grow':
      text = 'Это раздел с онлайн-курсами, которые можно начать бесплатно. Ребёнок попробует и поймёт, что хочет учить.'
      break
    default:
      text = 'Это раздел с тестами и тренажёрами. Открывайте подходящий и спокойно оставляйте ребёнка за экраном.'
      break
  }

  $('[data-type-text]').text(text)
}
